import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import classNames from 'classnames';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PersonIcon from '@material-ui/icons/Person';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField/index';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import FindInPageIcon from '@material-ui/icons/FindInPage';

import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
// Shared components
import Grid from '@material-ui/core/Grid';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import {templateView} from '../../../../services/Templates'
import NewTemplate from './AddTemplate'
import EditTemplate from './EditTemplate'
import DeleteTemplate from './DeleteTemplate'
import moment from 'moment'
import 'moment/locale/es'
import Popover from '@material-ui/core/Popover';
import NoData from '../../../../helpers/NoActiveSection'
import NoActive from '../../../../helpers/NoData'
import LimitTemplate from '../../../../helpers/LimitTemplate'
import { Button } from '@material-ui/core';
// Component styles
import styles from './styles';
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class TemplateManager extends Component {
    constructor(props) {
      super(props);
      this.myCallback = this.myCallback.bind(this);
      this.state = {
        isLoading: true,
        templateAdd:true,
        openModal: false,
        openModalDelete:false,
        activeSection:true,
        limitModal:false,
        open: false,
        contacts:[],
      }
  }
  
  onCloseModalPop = () => {
    this.setState({ open: null });
  };

  myCallback = (dataFromChild) => {
    this.setState({
        templateAdd: true,
        openModal: false,
        openModalDelete:false,
        deleteEl:false
    })
    setTimeout(() => 
      this.componentDidMount()
    ,1)
  }


  componentDidMount() {
    this.processData()
  }
  // Helper para procesar la data de la petición a la API

  processData = () => {
    const token = sessionStorage.getItem('key')
    const user = sessionStorage.getItem('user')
    templateView(user, token).then( value=>{
      if(value.status===4||value.status===5){
        this.setState({
          activeSection: false,
          isLoading: false,
          dataError:true
        });
      }else{
        value.dataTemplate.map(ele=>{
          var imgData=ele.icono.replace(/ /g, "")
          var img=""
          if(imgData.indexOf("data:")===-1){
            img ="data:image/png;base64,"+imgData
          }
          if(imgData===""){
            img=""
          }
          ele["url"]=<img src={img} style={{width: 50, borderRadius: '50%'}}/>
        })
        if(value.hasOwnProperty("status")){
          this.setState({
            activeSection: false,
            isLoading: false,
          });
        }else{
          this.setState({
            rows: value,
            isLoading: false,
            activeSection:true
          });
        }
      }
    })
  }

  handleShowEdit = (event, value, name) => {
    const {rows}=this.state
    if(name==="delete"){
      this.setState({
        deleteEl: [event, value],
        openModalDelete: true,
      });
    }else if(name==="users"){
      this.setState({
        open: event.currentTarget,
        contacts:value.destinatarios
      });
    }else{
      if(rows.dataTemplate.length>=rows.dataCliente.limite_plantillas_alerta_integracion){
        this.setState({
          limitModal: true,
          editEl: [event, value],
          openModal: true,
        });
      }else{
        this.setState({
          editEl: [event, value],
          openModal: true,
          limitModal: false,
        });
      }
    }
    
  };
  handleShowAdd =()=>{
    const {rows}=this.state
    if(rows.dataTemplate.length>=rows.dataCliente.limite_plantillas_alerta_integracion){
      this.setState({
        limitModal: true,
        templateAdd: false,
      });
    }else{
      this.setState({
        templateAdd: false,
        limitModal:false
      });
    }
  }
  handleCloseModal = event => {   
    this.setState({
        openModal: false,  
    })
  };
  handleCloseModalDelete = event => { 
    this.setState({
        openModalDelete: false,
        deleteEl:false
    })
  };

  handleCloseModalLimit=()=>{
    this.setState({
      templateAdd: true,
      limitModal:false
  })
  }


  render() {
      const { classes, className } = this.props;
      const { dataError, isLoading, rows, templateAdd, openModal, editEl, deleteEl, activeSection, limitModal, 
        open, contacts, periodEl} = this.state;
      const style = isLoading ? { display: 'none' } : {};
      const styleHidden = isLoading ? {} : { display: 'none' };
      const showOpenPop = Boolean(open);
      if(activeSection===true){
        if (!dataError) {
          return (<FormattedChart classes={classes} isLoading={isLoading} style={style} styleHidden={styleHidden} rows={rows} openModal={openModal}
                    handleShowEdit={this.handleShowEdit} templateAdd={templateAdd} handleTemplate={this.myCallback} edit={editEl}
                    handleShowAdd={this.handleShowAdd} handleCloseModal={this.handleCloseModal} limitModal={limitModal}
                    handleCloseModalDelete={this.handleCloseModalDelete} openModalDelete={deleteEl} contacts={contacts}
                    handleCloseModalLimit={this.handleCloseModalLimit} open={open} onCloseModalPop={this.onCloseModalPop}
                    showOpenPop={showOpenPop}
                  />) 
        }
          else if (dataError) {
            return<NoData/>
        }
          else return (<p> Error!</p >)
      }else{
        return<NoActive/>
      }
      
  }
}

function FormattedChart(props) {
  return (
    <div>
      { typeof(props.rows) == "undefined"  ? 
        <PortletContent style={{alignItems: 'center', position: 'absolute', top: '20%', left: '50%'}}>
                <Typography
                variant="h5"
                align="center"
                style={{paddingTop:"150px"}}

                >
                <CircularProgress
                variant="indeterminate"
                size={24}
                thickness={4}
                />
                <br/>
                Cargando Información...
            </Typography>
        </PortletContent>
      :
      props.templateAdd===true?
      <div style={{ maxWidth: "100%" }}>
          <MaterialTable
            className={props.classes.tag}
              icons={tableIcons}
              columns={[
                
                  {width: 100, title: "#", field: "id"/*, defaultGroupOrder: 0*/,headerStyle: {
                      backgroundColor: '#6d6d6d',
                      color: '#FFF'
                    } },
                  {width: 300,  title: "Nombre", field: "nombre" ,headerStyle: {
                      backgroundColor: '#6d6d6d',
                      color: '#FFF'
                    } },
                  {width: 300,  title: "Descripción", field: "descripcion"/*, type: "numeric"*/ ,headerStyle: {
                      backgroundColor: '#6d6d6d',
                      color: '#FFF'
                    } },
                  {width: 200, title: "Autor", field: "autor"/*, type: "numeric"*/,headerStyle: {
                      backgroundColor: '#6d6d6d',
                      color: '#FFF'
                    }},
                    {width: 100, title: "Icono", field: "url",headerStyle: {
                      backgroundColor: '#6d6d6d',
                      color: '#FFF'
                    } },
              ]}
              
              data={props.rows.dataTemplate} 
              title="• Template Alertas Extendidas."
              localization={{
                  grouping: {
                      groupedBy: 'Agrupar por:',
                      placeholder: 'Arrastre los encabezados aquí, para agrupar',
                  },
                  body: {
                      emptyDataSourceMessage: 'No hay datos'
                  },
                  toolbar: {
                      searchTooltip: 'Buscar',
                      searchPlaceholder: 'Buscar'
                  },
                  pagination: {
                      labelRowsSelect: 'Filas',
                      labelDisplayedRows: ' {from}-{to} de {count}',
                      firstTooltip: 'Pri. pág.',
                      previousTooltip: 'Pág. previa',
                      nextTooltip: 'Sig. pág.',
                      lastTooltip: 'Últ. pág'
                  },
                  header: {
                      actions: '',
                  },
              }}
              options={{
                  grouping: true,
                  actionsColumnIndex: -1,
                  headerStyle: {
                    backgroundColor: '#6d6d6d',
                    color: '#FFF'
                  }
              }}
              actions={[
                {
                  icon: AddCircleOutlineIcon,
                  tooltip: 'Agregar Template',
                  isFreeAction: true,
                  //onClick: (event) => alert("You want to add a new row")
                  onClick: props.handleShowAdd
                },
                rowData => ({
                  icon: PersonIcon,
                  tooltip: 'destinatarios',
                  onClick: (event, rowData) => props.handleShowEdit(event, rowData, 'users')
                }),   
                rowData => ({
                  icon: Edit,
                  tooltip: 'Editar contacto',
                  onClick: (event, rowData, name) => props.handleShowEdit(event, rowData, 'edit'),
                  disabled:rowData.status,
                }),
                rowData => ({
                  icon: DeleteOutline,
                  tooltip: 'Eliminar template',
                  onClick: (event, rowData, name) => props.handleShowEdit(event, rowData, 'delete'),
                  disabled:rowData.status,
                }),
              ]}
          />
          <Popover 
            anchorEl={props.open}
            open={props.showOpenPop} 
            onClose={props.onCloseModalPop} 
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}>
              <Grid item xs>
                  <Typography variant="h4">Destinatarios: 
                  </Typography>
              </Grid>
              {props.contacts.length===0?
              <Grid item xs>
                <Typography variant="h6">No tiene Destinatarios Asociados
                </Typography>
              </Grid>
              :
              props.contacts.map((ele, i)=>(
                <Grid container wrap="nowrap" spacing={2}>
                  
                  <Grid item xs>
                    <Typography variant="h5">{ele.destinatario}
                    </Typography>
                  </Grid>
                </Grid>
              ))
              }
          </Popover>
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={props.openModalDelete}
            onClose={props.handleCloseModalDelete}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop:"100px",
            }}
            disableAutoFocus={true}
            disableEnforceFocus={true}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
          >                                    
            <Fade in={props.openModalDelete}>
              <PerfectScrollbar>                         
                <DeleteTemplate row={props.openModalDelete} handleTemplate={props.handleTemplate}/>
              </PerfectScrollbar>
            </Fade>
          </Modal>
          {props.limitModal?
            <Modal
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              open={props.limitModal}
              onClose={props.handleCloseModalLimit}
              style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  inset:"70px",
              }}
              disableAutoFocus={true}
              disableEnforceFocus={true}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                  timeout: 500,
              }}
            >                                    
              <Fade in={props.limitModal}>                       
                  <LimitTemplate />
              </Fade>
            </Modal>
          :
            <Modal
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              open={props.openModal}
              onClose={props.handleCloseModal}
              style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  inset:"70px",
              }}
              disableAutoFocus={true}
              disableEnforceFocus={true}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                  timeout: 500,
              }}
            >                                    
              <Fade in={props.openModal}>
                <PerfectScrollbar>                         
                  <EditTemplate row={props.edit} handleTemplate={props.handleTemplate}/>
                </PerfectScrollbar>
              </Fade>
            </Modal>
          }
        </div>
      :
      props.limitModal?
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={props.limitModal}
        onClose={props.handleCloseModalLimit}
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            inset:"70px",
        }}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
            timeout: 500,
        }}
      >                                    
        <Fade in={props.limitModal}>                       
            <LimitTemplate />
        </Fade>
      </Modal>
      :
      <NewTemplate data={props.rows} handleTemplate={props.handleTemplate}/> 
      }
  </div>
      
  )

}

export default withStyles(styles)(TemplateManager);
